import { formatAddress } from '@/utils/format';

export default {
    methods: {
        formatSystemAddress(system) {
            return formatAddress(system);
        },
        getUserRole(system, userId) {
            let userRole = ''
            if(system && system.users && system.users.find(sysUser => sysUser.id === userId )) {
                const matchingUser = system.users.find(sysUser => sysUser.id === userId )
                userRole = this.$t('systems.permission.' + matchingUser.permission_text)
            }
            return userRole
        }
    }
}